<template>
  <div class="wizzard-step-account-modes">
    <UIRadiobox
      v-model="useExisting"
      :label="`Use existing ${name}`"
      :disabled="!hasExistingAccounts"
      :value="true"
    />
    <UIRadiobox
      v-model="useExisting"
      :label="`Create new ${name}`"
      :value="false"
    />
  </div>
</template>

<script setup lang="ts">
import { UIRadiobox } from '@ui/controllers'

type Props = {
  hasExistingAccounts: boolean
  name: string
}

defineProps<Props>()

defineOptions({ inheritAttrs: false })

const useExisting = defineModel<boolean>()
</script>

<style>
.wizzard-step-account-modes {
  @apply flex flex-col gap-2;
}
</style>
